module.exports = __webpack_public_path__ + "media/images/MarcaBranca-old-6b04f516bc292da2850f188b3983b8c8.png";